export default __webpack_public_path__ + "static/media/NZ.56f12c9f.svg";